const StoreIcon = () => {
  return (
    <svg
      id="Group_9458"
      data-name="Group 9458"
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      viewBox="0 0 30 30"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_5543"
            data-name="Rectangle 5543"
            width={30}
            height={30}
            fill="#707070"
          />
        </clipPath>
      </defs>
      <g id="Group_9457" data-name="Group 9457" clipPath="url(#clip-path)">
        <path
          id="Path_12182"
          data-name="Path 12182"
          d="M29.835,6.523,26.525.888A1.777,1.777,0,0,0,25,0H5.026A1.777,1.777,0,0,0,3.5.884L.165,6.523,0,7.135a5.867,5.867,0,0,0,5.769,5.946,5.622,5.622,0,0,0,4-1.688.864.864,0,0,1,1.235,0,5.578,5.578,0,0,0,8,0,.864.864,0,0,1,1.235,0,5.623,5.623,0,0,0,4,1.688A5.867,5.867,0,0,0,30,7.135Z"
          transform="translate(0 0)"
          fill="#707070"
        />
        <path
          id="Path_12183"
          data-name="Path 12183"
          d="M115.33,522.9a7.784,7.784,0,0,1-4.1-1.161.972.972,0,0,0-1.026,0,7.829,7.829,0,0,1-8.205,0,.972.972,0,0,0-1.026,0,7.79,7.79,0,0,1-6.3.84,1,1,0,0,0-1.261.98L93.4,537.33a1,1,0,0,0,.988,1.021l6.106.01a1,1,0,0,0,.991-1.02V526.355a1,1,0,0,1,.99-1.02h7.251a1,1,0,0,1,.99,1.02v10.987a1,1,0,0,0,.99,1.02h6.083a1,1,0,0,0,.99-1.019l.013-13.779a1,1,0,0,0-1.261-.982,7.719,7.719,0,0,1-2.2.32"
          transform="translate(-91.099 -508.362)"
          fill="#707070"
        />
      </g>
    </svg>
  )
}

export default StoreIcon
